import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { TopSpacer } from "./PatientLandingView.styles";
import { PreLoginBaseView } from "./PreLoginPageBaseView";
import { RedirectToPatientPortalEmbedViewModel } from "./RedirectToPatientPortalEmbedViewModel";
import { spinner } from "./Spinner";
import { useViewModel } from "./useViewModel";
import { Text } from "./HXMobilePage.styles";
import { HXMobileButton } from "./HXButton";
import { FlexColumn } from "./common.styles";
export const RedirectToPatientPortalEmbedView = observer((props) => {
    var _a, _b;
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(RedirectToPatientPortalEmbedViewModel, props.container);
    if (model.healthcareOrganization === NOT_LOADED ||
        model.patientPortalName === NOT_LOADED ||
        model.patientPortalAppName === NOT_LOADED ||
        model.appInstallButtonVisible === NOT_LOADED) {
        return spinner();
    }
    if (model.mobileAppShouldHaveLaunched) {
        return (_jsxs(PreLoginBaseView, { title: t("Don't have {{ patientPortalAppName }} installed?", { patientPortalAppName: model.patientPortalAppName }), organization: (_a = model.healthcareOrganization) !== null && _a !== void 0 ? _a : undefined, topImage: _jsx(TopSpacer, {}), container: props.container, showLanguageSwitcher: true, children: [_jsx(FlexColumn, { gap: 16, children: _jsx(Text, { children: t("If not, click the button below to install {{patientPortalAppName}}.", {
                            patientPortalAppName: model.patientPortalAppName,
                        }) }) }), _jsxs(_Fragment, { children: [_jsx(HXMobileButton, { onClick: () => model.installApp(), children: t("Install {{patientPortalAppName}}", { patientPortalAppName: model.patientPortalAppName }) }), _jsx(HXMobileButton, { text: true, onClick: () => model.launchOnWeb(), children: t("Use the browser version of {{patientPortalName}} instead", { patientPortalName: model.patientPortalName }) })] })] }));
    }
    else {
        return (_jsxs(PreLoginBaseView, { title: t("Redirecting you to {{ patientPortalName }}...", { patientPortalName: model.patientPortalName }), organization: (_b = model.healthcareOrganization) !== null && _b !== void 0 ? _b : undefined, topImage: _jsx(TopSpacer, {}), container: props.container, showLanguageSwitcher: true, children: [spinner(), _jsx(_Fragment, {})] }));
    }
});
